var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"glyphicon",class:{ 'text-success glyphicon-ok' : _vm.status, 'text-danger glyphicon-remove' : !_vm.status },attrs:{"aria-hidden":"true"},on:{"click":_vm.toggleStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }